var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.ext == 'pdf')?_c('pdf',{attrs:{"src":this.imageUrl}}):_vm._e(),_vm._v(" "),(_vm.ext != 'pdf')?_c('img',{attrs:{"src":this.imageUrl}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229add6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/templates/ViewFile.html
// module id = null
// module chunks = 